import * as React from 'react'

function SvgWrench(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width="1em" height="1em" {...props}>
			<path
				fill="currentColor"
				d="M14.676 14.005a.671.671 0 11-1.342.001.671.671 0 011.342-.001zM5.514 2.685c.273 1.26-1.553 3.107-2.828 2.828L.172 3A4.23 4.23 0 000 4.195 4.178 4.178 0 004.507 8.36a2.139 2.139 0 011.676.62l6.441 6.441a1.978 1.978 0 102.797-2.797L8.98 6.184a2.14 2.14 0 01-.62-1.676A4.18 4.18 0 007.145 1.22 4.157 4.157 0 004.194 0 4.25 4.25 0 003 .171z"
			/>
		</svg>
	)
}

export default SvgWrench
